<template>
  <label class="input-inside-chat-label">
    <span v-if="text">{{ text }}</span>
    <input
      v-model="date"
      type="text"
      readonly
      :class="['input-inside-chat', { error: validate.$invalid && validate.$dirty }]"
      @click="openDateWidget"
    />
  </label>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import { useBottomPanelStore } from 'Store/bottom-panel'
import { useDatepickerStore } from 'Store/datepicker'

export default {
  name: 'ChatDatePicker',

  setup() {
    return {
      bottomPanelStore: useBottomPanelStore(),
      datepickerStore: useDatepickerStore()
    }
  },

  props: {
    text: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    settings: {
      type: Object,
      default: () => ({})
    },
    validate: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    return {
      date: this.value,
      inputUUID: uuidv4()
    }
  },

  computed: {
    currentDate() {
      return this.datepickerStore.settings.currentDate
    }
  },

  watch: {
    currentDate(newValue) {
      if (this.datepickerStore.settings.uuid === this.inputUUID) {
        this.date = newValue
        this.$emit('input', newValue)
      }
    }
  },

  methods: {
    openDateWidget() {
      const disabledDates = {}
      const enabledDates = {
        dates: this.settings.enabled_dates
      }

      this.bottomPanelStore.setBottomPanelComponent('DatePickerPanel')
      this.bottomPanelStore.setBottomPanelInputFor('TemplateForm')
      this.datepickerStore.setTimeSettings({
        enabled_dates: this.settings.enabled_dates,
        currentDate: this.date,
        uuid: this.inputUUID
      })
      this.datepickerStore.setInventory({})
      this.datepickerStore.setDateRange([])
      this.datepickerStore.enableDateRange(false)
      this.datepickerStore.setDisabledDates(disabledDates)
      this.datepickerStore.setEnabledDates(enabledDates)
    }
  }
}
</script>
